<template>
    <div>
        <header>
            <div class="container">
                <nav class="navbar navbar-expand-lg">
                    <a class="navbar-brand" href="index.html"><img src="../assets/logo.svg" alt="img" class="img-fluid"></a>
                    <div class="header-right">
                        <div class="logged-user">
                            <h4>{{firstName}} {{lastName}}</h4>
                        </div>
                    </div>
                </nav>
            </div>
        </header>

        <section class="dashboard">

            <div class="container">

                <div v-show="isCandidateApproved" class="row">

                    <div class="col-sm-12 col-md-12 col-lg-7">
                        <div class="left-area">

                            <div class="pre-qualified">

                                <div class="result-head">
                                    <h2>Congratulations {{firstName}} {{lastName}}!</h2>
                                    <h3 v-if="!hideCreditScoreOnConsumerDashboard">Your <strong>{{creditScore}}</strong> score means you’re <span>pre-qualified</span>.</h3>
                                    <h3 v-else>You're <span>pre-qualified</span>.</h3>
                                </div>

                                <div v-if="!hideAverageLoanAmountOnConsumerDashboard && !hideAverageAPROnConsumerDashboard" class="result-items">
                                    <ul>
                                        <li>
                                            <h4 v-if="hideAverageLoanAmountOnConsumerDashboard" class="treadopen-btn"></h4>
                                            <h4 v-else>${{averageLoanAmountFormatted}}</h4>
                                            <p>Average loan</p>
                                        </li>
                                        <li>
                                            <h4 v-if="hideAverageAPROnConsumerDashboard" class="treadopen-btn"></h4>
                                            <h4 v-else>{{loanAPRAverage}}</h4>
                                            <p>Average Rate/APR</p>
                                        </li>
                                        <li>
                                            <h4>{{loanTermMonths}}mo</h4>
                                            <p>Loan term</p>
                                        </li>
                                    </ul>
                                </div>

                                <!--<div class="pre-head">
            <h2>You're Pre-Qualified!</h2>
        </div>

        <div class="pre-meter">
            <h4>Your free FICO credit score</h4>
            <div class="meter-block">
                <CandidateFICOChart v-bind:creditScore="creditScore" />
            </div>
        </div> -->
                                <!--
        <div class="pre-chart">
            <div class="chart-block">
                <h4>Score history</h4>
                <canvas id="canvas" width="300" height="170" class="chartjs-render-monitor"></canvas>
            </div>
        </div>
        -->
                                <!--
        <div class="pre-balance">
            <h3 :class="creditColor">{{creditScoreCategoryUpperCase}}</h3>
            <ul>
                <li>
                    <strong>${{balances}}</strong>
                    <span>Balances</span>
                </li>
                <li>
                    <strong>{{creditUtilization}}%</strong>
                    <span>Credit Utilization</span>
                </li>
                <li>
                    <strong>{{paymentHistory}}%</strong>
                    <span>Payment history</span>
                </li>
            </ul>
        </div>
            -->

                                <!--<CandidateAutoCardsContainer v-bind:isCandidateApproved="isCandidateApproved"
                                                             v-bind:averageLoanAmountFormatted="averageLoanAmountFormatted"
                                                             v-bind:loanAPRMin="loanAPRMin"
                                                             v-bind:loanAPRMax="loanAPRMax"
                                                             v-bind:loanTermMonths="loanTermMonths"
                                                             v-bind:salesRepFirstName="salesRepFirstName"
                                                             v-bind:salesRepLastName="salesRepLastName"
                                                             v-bind:salesRepPhoneNumber="salesRepPhoneNumber"
                                                             v-bind:salesRepEmail="salesRepEmail"
                                                             v-bind:slides="autoLines" />-->

                                <div v-if="showLevelCreditLogin" style="border-bottom: none;margin-bottom: 0;float: left; width: 100%;">
                                    <h4 style="font-weight: 700; margin: 0 0 21px 0; font-size: 20px; }">To create an account with our partner LevelCredit by Self, please agree to the Level Credit <a href="https://www.levelcredit.com/terms" target="_blank">terms of service</a> and <a href="https://www.levelcredit.com/privacy-policy" target="_blank">privacy policy.</a></h4>

                                    <form style="margin-bottom:30px;">
                                        <div class="form-check" style="cursor:pointer!important;">
                                            <input v-model="agreedToLevelCreditTermsAndPrivacyPolicy" class="form-check-input" type="checkbox" id="defaultCheck1" style="cursor:pointer!important;">
                                            <label class="form-check-label" for="defaultCheck1" style="cursor:pointer!important;">
                                                I agree to the LevelCredit by Self <a href="https://www.levelcredit.com/terms" target="_blank">terms of service</a> and <a href="https://www.levelcredit.com/privacy-policy" target="_blank">privacy policy</a>
                                            </label>
                                        </div>
                                    </form>

                                    <div v-show="agreedToLevelCreditTermsAndPrivacyPolicy" style="float: left;padding: 15px 20px; border-radius: 4px; color: #111; font-size: 18px; font-weight: 700; text-align: center; margin: 2px 0 10px 0;background: #21cc6f; width: auto;certificate-cto">
                                        <a class="btn-pink" data-v-5dc2a032="" target="_blank" :href="'/api/Candidate/CreateAndSignInToCreditImprovementService/' + candidateGuid" style="background: #21cc6f;width: 100%;color: #fff;">Continue to LevelCredit by Self</a>
                                    </div>
                                </div>
                                <div v-else class="" style="border-bottom: none;margin-bottom: 0;float: left; width: 100%;">
                                    <div v-if="creditImprovementServiceStatus == 'cantcreateaccount'">
                                        <p>Text to show when a LevelCredit account can't be created.</p>
                                    </div>
                                    <div v-else>
                                        <h4 style="font-weight: 700; margin: 0 0 21px 0; font-size: 20px; }">Want to qualify for an even better rate?</h4>
                                        <ul style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; }">
                                            <li style="width: 35%;">
                                                <div style=""><img src="https://www.levelcredit.com/hubfs/LevelCredit/logos/home-score.png" style="width: 100%; height: auto;bkit-fill-available;"></div>
                                            </li>
                                            <li style="width: 65%;padding-left: 25px;">
                                                <p style="padding-bottom: 9px;">With our partner, LevelCredit by Self you can now add your rent, cell phone, water, gas &amp; electricity payment to your credit score with the major credit bureaus. <strong>Drive up your credit score + buying power, drive down your rates</strong>.</p>
                                                <div style="float: left;padding: 15px 20px; border-radius: 4px; color: #111; font-size: 18px; font-weight: 700; text-align: center; margin: 2px 0 10px 0;background: #21cc6f; width: 70%;certificate-cto">
                                                    <a href="https://www.self.inc/" class="btn-pink" data-v-5dc2a032="" style="background: #21cc6f;width: 100%;color: #fff;">{{showLevelCreditLoginButtonText}}</a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div class="result-area">

                                <div class="result-steps">
                                    <h3>Just a few easy steps to follow:</h3>
                                    <ul>
                                        <li>
                                            <div class="step-num">1</div>
                                            <h4>Keep this pre-qualifiction certificate</h4>
                                            <p><a @click.prevent="EmailCouponToApplicant" href="#">Save</a> or <a href="#" @click.prevent="SendCouponToDealership">send</a> your pre-qualification certificate</p>
                                        </li>
                                        <li>
                                            <div class="step-num">2</div>
                                            <h4>Visit or Call {{dealershipName}}</h4>
                                            <p>{{dealershipStreetAddress}},<br> {{dealershipCity}}, {{dealershipStateCode}} {{dealershipZipCode}} <br><a :href="'tel:' + dealershipPhoneNumber">{{dealershipPhoneNumberFormatted}}</a></p>
                                        </li>
                                        <!--<li>
                                            <div class="step-num">3</div>
                                            <h4>Get your deal, and get an additional <span>${{certificateDiscount}}</span> off </h4>
                                            <p>With the attached certificate — valid thru {{certificateValidThru}}</p>
                                        </li>-->
                                    </ul>
                                </div>

                            </div>

                        </div>
                    </div>


                    <div class="col-sm-12 col-md-12 col-lg-5">
                        <div class="right-area">

                            <div class="right-block">

                                <div class="your-certificate">

                                    <div class="qrcode">
                                        <img src="../assets/bar-code.svg" alt="img" class="img-fluid">
                                    </div>

                                    <div class="certificate">
                                        <h3>Your certificate <span>Valid thu {{certificateValidThru}}</span></h3>
                                        <div class="result-side" v-if="hideAverageLoanAmountOnConsumerDashboard && hideAverageAPROnConsumerDashboard">
                                            <div v-if="!hideCreditScoreOnConsumerDashboard" class="result-side-vertical">
                                                <span>Credit score</span>
                                                <strong>{{creditScore}}</strong>
                                            </div>
                                            <div class="result-side-pre-qualified">
                                                <h3><span>Pre-qualified</span></h3>
                                            </div>
                                            <div style="clear:both;"></div>
                                        </div>
                                        <ul v-else>
                                            <li class="highlight">
                                                <span>Average Loan</span>
                                                <span v-if="hideAverageLoanAmountOnConsumerDashboard" class="treadopen2-btn"></span>
                                                <strong v-else>${{averageLoanAmountFormatted}}</strong>
                                            </li>
                                            <li>
                                                <span>Loan term</span>
                                                <strong>Up to {{loanTermMonths}} mos</strong>
                                            </li>
                                            <li>
                                                <span>Average Rate/APR</span>
                                                <span v-if="hideAverageAPROnConsumerDashboard" class="treadopen2-btn"></span>
                                                <strong v-else>{{loanAPRAverage}}</strong>
                                            </li>
                                            <li>
                                                <span>Credit score</span>
                                                <strong>{{creditScore}}</strong>
                                            </li>
                                        </ul>
                                    </div>

                                    <!--<div class="voucher">
                                        <div class="voucher-img">
                                            <img src="../assets/car.png" alt="img" class="img-fluid">
                                        </div>
                                        <div class="voucher-det">
                                            <h2>${{certificateDiscount}} OFF</h2>
                                            <p>Coupon is valid thru {{certificateValidThru}}.</p>
                                            <a v-if="couponSentToDealershipOn == ''" href="#" @click.prevent="SendCouponToDealership" class="send-coupon-link">Send this coupon to dealership</a>
                                            <span v-else>Coupon sent to dealership on: {{couponSentToDealershipOn}}</span>
                                        </div>
                                    </div>-->

                                    <div class="certificate-cto">
                                        <a v-if="couponSentToDealershipOn == ''" href="#" @click.prevent="SendCouponToDealership" class="btn-pink">Send to dealership</a>
                                        <a @click.prevent="EmailCouponToApplicant" href="#" class="btn-pink">Save a certificate</a>
                                    </div>

                                </div>

                                <div class="dashed-strip">
                                    <hr>
                                </div>

                                <div class="pick-car">
                                    <h3>Go pick up your car!</h3>
                                    <div class="car-dealer">
                                        <div class="dealer-logo">
                                            <img :src="urlToLogo" alt="logo" class="img-fluid">
                                        </div>
                                        <div class="dealer-det">
                                            <h4>{{salesRepFirstName}} {{salesRepLastName}} </h4>
                                            <span>Sales Associate</span>
                                            <a :href="'tel:' + salesRepPhoneNumber">{{salesRepPhoneNumber}}</a>
                                            <a :href="'mailto:' + salesRepEmail">{{salesRepEmail}}</a>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                <div v-show="!isCandidateApproved" class="row">

                    <div class="col-sm-12 col-md-12 col-lg-7">
                        <div class="left-area">

                            <div class="pre-qualified">
                                <div class="result-head turn-down">
                                    <h2>James, you’re not prequalified yet.</h2>
                                    <h3>A <strong><span class="creditScoreClass">{{creditScore}}</span></strong> score is not the end of the road.</h3>
                                </div>

                                <div class="approved-det">
                                    <h4>You have options to change your score</h4>
                                    <p>Join over 1.26M people adding their cell phone, utility and rent payments to their credit score. Finally, there’s a debt free way to quickly build your score and <strong>get approved</strong> — using the bills you’re already paying.</p>
                                </div>
                                <div class="approved-logo">
                                    <img src="../assets/lc-logo-2.svg" alt="img" class="img-fluid">
                                </div>
                                <div class="approved-partner approved-partner-turndown">
                                    <p>LevelCredit by Self is an affiliate partner</p>
                                    <a class="text-link" target="_blank" href="https://www.self.inc/">Build my score and get approved</a>
                                    <div class="btn-link build-score-cta turndown-btn">
                                        <a target="_blank" href="https://www.self.inc/" class="btn-pink">Build your score - get approved</a>
                                    </div>
                                </div>

                                <div class="qualified-box">
                                    <div class="cards-box">
                                    </div>
                                </div>

                            </div>
                            <div class="result-area turn-down quote">

                                <div class="result-steps">
                                    <h4>"Reporting my rent boosted my credit score which in turn helped with my auto refinancing. Saved me over $8,000."</h4>
                                    <p>Nnamdi A. - Real credit builder</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-5">
                        <div class="right-area">

                            <div class="result-area turn-dow steps">

                                <div class="result-steps">
                                    <h3>Just a few steps to get qualified:</h3>
                                    <ul>
                                        <li>
                                            <div class="step-num">1</div>
                                            <h4>Sign up to LevelCredit by Self</h4>
                                            <p><a target="_blank" href="https://www.self.inc/">Get started</a> for just $6.95. No commitments - use it until your qualified.</p>
                                        </li>
                                        <li>
                                            <div class="step-num">2</div>
                                            <h4>Build your credit score</h4>
                                            <p>Use your monthly rent, cell phone & utility bills to build your score.</p>
                                        </li>
                                        <li>
                                            <div class="step-num">3</div>
                                            <h4>We'll re-run and get you qualified</h4>
                                            <p>No catch. Once your score builds, you'll be pre-qualified for you loan.</p>
                                        </li>
                                    </ul>
                                    <div class="build-score-cta turndown-btn">
                                        <a target="_blank" href="https://www.self.inc/" class="btn-pink">Build your score - get approved</a>
                                    </div>

                                </div>

                            </div>

                            <div class="result-area levelcredit-img">

                                <img src="../assets/needs-work.png" alt="img" class="img-fluid">

                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </section>

        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="copyright">
                            <p>&copy; 2022 CreditDriver</p>
                            <p>180 Fitzgerald Road, Suite 1, Lakeland, FL 33813</p>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="footer-links">
                            <a target="_blank" href="https://creditdriver.com/contactus.html">Contact us</a>
                            <a target="_blank" href="https://creditdriver.com/terms.html">Terms &amp; Privacy</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    </div>
</template>

<script>
    //import CandidateAutoCardsContainer from './CandidateAutoCardsContainer.vue';
    import creditDriverApi from '../creditDriverApi';
    import { vm } from '../main';

    export default {
        name: 'CandidateDashboard',
        computed: {
            averageLoanAmountFormatted() {
                if (this.averageLoanAmount != undefined) {
                    return this.averageLoanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    return "";
                }

            },
            creditColor() {
                return this.creditScoreCategory + "-color";
            },
            creditScoreCategory() {
                if (this.creditScore > 750) {
                    return "best";
                }
                else if (this.creditScore > 670) {
                    return "fair";
                }
                else if (this.creditScore > 580) {
                    return "poor";
                }
                else {
                    return "worst";
                }
            },
            creditScoreCategoryUpperCase() {
                return this.creditScoreCategory.charAt(0).toUpperCase() + this.creditScoreCategory.slice(1);
            },
            dealershipPhoneNumberFormatted() {
                return this.dealershipPhoneNumber.slice(0,3) + "-" + this.dealershipPhoneNumber.slice(3,6) + "-" + this.dealershipPhoneNumber.slice(6);
            },
            showLevelCreditLoginButtonText() {
                if (this.creditImprovementServiceStatus == "createaccountallowed") {
                    return "Drive your credit score";
                } else {
                    return "Go to LevelCredit by Self";
                }
            }
        },
        props: {
            candidateId: Number,
            candidateGuid: String,
            firstName: String,
            lastName: String,
            dealershipName: String,
            dealershipStreetAddress: String,
            dealershipCity: String,
            dealershipStateCode: String,
            dealershipZipCode: String,
            dealershipPhoneNumber: String,
            hideAverageAPROnConsumerDashboard: Boolean,
            hideAverageLoanAmountOnConsumerDashboard: Boolean,
            hideCreditScoreOnConsumerDashboard: Boolean,
            salesRepPhoneNumber: String,
            salesRepFirstName: String,
            salesRepLastName: String,
            salesRepEmail: String,
            sessionId: String,
            creditScore: Number,
            autoLines: Array,
            urlToLogo: String
        },
        watch: {
            candidateId: {
                handler: function () {
                    this.GetCandidateCertificate();
                }
            },
            candidateGuid: {
                handler: function () {
                    this.CandidateGuidChanged();
                }
            }
        },
        data: function () {
            return {
                balances: "0",
                averageLoanAmount: "0",
                candidateCertificateGuid: '',
                certificateDiscount: "0",
                certificateValidThru: "",
                creditUtilization: "7",
                couponSentToDealershipOn: "",
                loanAPRMin: "0.00",
                loanAPRMax: "0.00",
                loanTermMonths: "0",
                paymentHistory: "100",
                isCandidateApproved: true,
                showLevelCreditLogin: false,
                agreedToLevelCreditTermsAndPrivacyPolicy: false,
                creditImprovementServiceStatus: "createaccountallowed"
            }
        },
        methods: {
            toggleApproved() {
                this.isCandidateApproved = !this.isCandidateApproved;
            },
            CandidateGuidChanged() {
                this.isLoading = true;
                creditDriverApi.getCheckForCreditImprovementServiceUsers(this.candidateGuid).then(response => {
                    if (response.data != null) {
                        if (response.data) {
                            this.creditImprovementServiceStatus = response.data;
                        }
                    }

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            toggleShowLevelCreditLogin() {
                this.isLoading = true;
                creditDriverApi.getCheckForCreditImprovementServiceId(this.candidateGuid).then(response => {
                    if (response.data != null) {
                        if (response.data) {
                            this.showLevelCreditLogin = false;
                            window.open('/api/Candidate/CreateAndSignInToCreditImprovementService/' + this.candidateGuid, '_blank');
                        }
                        else {
                            this.showLevelCreditLogin = !this.showLevelCreditLogin;
                        }
                    }

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            GetCandidateCertificate() {
                this.isLoading = true;
                creditDriverApi.getCandidateCertificateFromCandidateId({
                    candidateId: this.candidateId,
                }).then(response => {
                    if (response.data != null) {
                        this.candidateCertificateGuid = response.data.candidateCertificateGUID;
                        this.certificateDiscount = response.data.certificateDiscount;
                        this.loanAPRMin = response.data.rateAPRMinimum;
                        this.loanAPRMax = response.data.rateAPRMaximum;
                        this.loanAPRAverage = response.data.rateAPRAverage;
                        this.loanTermMonths = response.data.loanTermMonths;
                        this.averageLoanAmount = response.data.averageLoanAmount;
                        this.certificateDiscount = response.data.discountAmount;
                        this.certificateValidThru = response.data.certificateValidThru;
                    }

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            SendCouponToDealership() {
                this.isLoading = true;
                creditDriverApi.postSendCouponToDealership({
                    sessionId: this.sessionId
                }).then(response => {
                        if (response.data != null) {
                            this.couponSentToDealershipOn = response.data;
                            vm.$toast.success('Your coupon has been sent to the dealership.', {
                                position: 'top-right',
                                duration: 3000
                            });
                        }

                        this.isLoading = false;
                    }).catch(error => {
                        console.log(error);
                    }).finally(function () {

                    });
            },
            EmailCouponToApplicant() {
                this.isLoading = true;
                creditDriverApi.postEmailCandiateCertificateToApplicant({
                    sessionId: this.sessionId
                }).then(response => {
                    if (response.data != null) {
                        this.couponSentToDealershipOn = response.data;
                        vm.$toast.success('Your pre-qualification certificate has been emailed to you.', {
                            position: 'top-right',
                            duration: 3000
                        });
                    }

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            }
        },
        mounted() {
            this.GetCandidateCertificate();
        },
        components: {
            //CandidateAutoCardsContainer
        }
    }


</script>

<style scoped>
    @import '../css/dashboardstyle.css';
    @import '../css/dashboardresponsive.css';
</style>